module.exports = __webpack_public_path__ + "img/mind_background_4_th.ba324a7f.png";